import api from './api';

export async function getOwnerPayouts() {
  const response = await api.get('/owner/payouts');
  return response.data;
}

export async function getOwnerPayoutBookings(payoutId) {
  const response = await api.get(`/owner/payouts/${payoutId}/bookings`);
  return response.data;
}

export async function savePayoutAccount(account) {
  const response = await api.put('/owner/payout-account', account);
  return response.data;
}
